/* ****** axios配置文件 ****** */
import axios from "axios"; // 引入axios

//设置请求超时
axios.defaults.timeout = 10000;
// 请求地址
axios.defaults.baseURL = 'https://api.vogemotor.com/index.php'

export default axios
